import React, { useEffect } from "react";
import { useState } from "react";
import { takeFive, takeFiveOverview, takeFiveSection } from "./TakeFivePageSelector";
import { TakeFiveView } from "./TakeFiveView"
import './TakeFive.css'
import { TakeFiveOverview } from "./TakeFiveOverview";
import { TakeFiveFormContents } from "./TakeFiveFormContents";


interface TakeFiveContainerProps {
    currentView: TakeFiveView
}

const TakeFiveContainer = (props: TakeFiveContainerProps) => {

    return (
        <>
            {props.currentView === TakeFiveView.Overview &&
                <TakeFiveOverview
                    view={[TakeFiveView.Overview]}
                    title={"Submitted Take 5s"}
                />
            }

            {props.currentView === TakeFiveView.TakeFive &&
                <TakeFiveFormContents />
            }
        </>
    );
};

interface TitleProps {
    title: string,
    titleIcon?: any
}

const TitleContainer = (props: TitleProps) => {
    return (
        <div className="tf-list-title">
            {props.titleIcon}
            <div className="tf-list-title-text">{props.title}</div>
        </div>
    );
}

interface TabsProps {
    tabs: TakeFiveView[],
    currentView: TakeFiveView,
    setCurrentView: any,
    visible?: boolean
}

const TabsContainer = (props: TabsProps) => {

    const getTabLabel = (view: TakeFiveView) => {
        let selectedPage = takeFiveSection;

        if (view == TakeFiveView.Overview) {
            selectedPage = takeFiveOverview;
        }

        if (view == TakeFiveView.TakeFive) {
            selectedPage = takeFive;
        }

        let title = selectedPage.label;
        if (title.startsWith("\u2003")) {
            title = title.substr(title.indexOf(" ") + 1);
        }

        return title;
    }

    useEffect(() => {
    }, [props.currentView]);

    if (!props.visible) {
        return (<></>);
    }

    return (
        <div className="tf-list-tabs">
            {props.tabs.map((view) =>
                <div key={view} className={`tf-tab${view === props.currentView ? " tf-tab-selected" : ""}`} onClick={() => props.setCurrentView(view)}>
                    {getTabLabel(view)}
                </div>
            )}
        </div>
    );
}

interface TakeFiveCardListProps {
    view: TakeFiveView[],
    title: string,
    titleIcon?: any,
}

export const TakeFiveCardList = (props: TakeFiveCardListProps) => {
    const [currentView, setCurrentView] = useState(props.view[0]);

    const updateCurrentView = (view: TakeFiveView) => {
        setCurrentView(view);
    }

    return (
        <>
            <TitleContainer
               titleIcon={props.titleIcon}
                title={props.title} />

            <TabsContainer
                tabs={props.view}
                currentView={currentView}
                setCurrentView={updateCurrentView}
                visible={props.view.length > 1}
            />

            <TakeFiveContainer
                currentView={currentView}
            />
        </>
    );
}